import { Box, Card, Grid } from '@mui/material';
import {
    Caption,
    FONT_WEIGHT,
    Heading,
    LINE_HEIGHT,
    SubHeading,
    TEXT_SIZE
} from '@/typography/Typography';
import { toDecimal, useFormatting } from '@/utils/formatting';
import { cardStyles } from './CardStyles';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { UserContext } from '@/contexts/user/UserContext';

export interface TipsOverviewProps {
    tipsTotal: number;
    earnedLastShift: number;
}

export const TipsOverview = ({
    tipsTotal,
    earnedLastShift
}: TipsOverviewProps) => {
    const { getBalanceLabelV2 } = useFormatting();
    const { t } = useTranslation();
    const { company } = useContext(UserContext);

    return (
        <Card style={cardStyles}>
            <Heading fontSize={TEXT_SIZE.SMALL}>{t('tips.tips')}</Heading>

            <Grid mb={2} mt={2} container justifyContent={'space-around'}>
                <Grid
                    textAlign={'center'}
                    item
                    direction={'column'}
                    alignItems={'center'}
                >
                    <SubHeading>
                        {getBalanceLabelV2(tipsTotal, company.currency, {
                            showNegativeStyle: true
                        })}
                    </SubHeading>
                    <Box m={1}></Box>
                    <Caption> {t('tips.total_earned')} </Caption>
                </Grid>

                <Grid
                    item
                    textAlign={'center'}
                    direction={'column'}
                    alignItems={'center'}
                >
                    <SubHeading>
                        {getBalanceLabelV2(earnedLastShift, company.currency, {
                            showNegativeStyle: true
                        })}
                    </SubHeading>
                    <Box m={1}></Box>
                    <Caption>{t('tips.earned_last_shift')}</Caption>
                </Grid>
            </Grid>
        </Card>
    );
};
